import { styled, Toolbar } from '@mui/material'

export const HeaderContainer = styled(Toolbar)`
  justify-content: space-between;
  align-items: center;
  padding: 0;
`
